<template>
  <div class="page-container module">
    <!-- Topbar -->
    <top-bar title="Users"></top-bar>

    <router-view></router-view>
  </div>
</template>

<script>
import TopBar from '@/components/TopBar.vue';

export default {
  name: 'User',
  components: {
    TopBar,
  },
};
</script>